export default __webpack_public_path__ + "static/media/Fence's Cord of Whispered Deeds.3266b0be.jpg";